import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { IEnvironment } from 'app/projects/core/src/lib/interfaces/environment.interface';
import { MAXBRAIN_ENVIRONMENT } from 'app/projects/core/src/lib/services/environment.token';
import * as _ from 'lodash';

@Injectable()
export class MaxBrainCustomTranslateService {
    private apiUrl: string;

    constructor(private _http: HttpClient, @Inject(MAXBRAIN_ENVIRONMENT) { apiUrl }: IEnvironment) {
        this.apiUrl = apiUrl;
    }

    async getTranslationsByKey(key: string): Promise<any> {
        return this._http.get<any>(`${this.apiUrl}/translations/${key}`).toPromise();
    }

    async updateTranslationsByKey(key: string, data: any): Promise<any> {
        return this._http.put<any>(`${this.apiUrl}/translations/${key}`, data).toPromise();
    }
}
